export default __webpack_public_path__ + "static/media/ois.79115ef6.png";